import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { initPhoneConversionUpdater } from './utils/tracking';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Services from './components/Services/Services';
import Benefits from './components/Benefits/Benefits';
import WhyChooseUs from './components/WhyChooseUs/WhyChooseUs';
import Testimonials from './components/Testimonials/Testimonials';
import FAQ from './components/FAQ/FAQ';
import CtaBanner from './components/CtaBanner/CtaBanner';
import BookingForm from './components/BookingForm/BookingForm';
import DataRecovery from './components/DataRecovery/DataRecovery';
import About from './components/About/About';
import Electrician from './components/Electrician/Electrician';
import IphoneRepair from './components/IphoneRepair/IphoneRepair';
import Footer from './components/Footer/Footer';
import FloatingContact from './components/FloatingContact/FloatingContact';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import RefundCancellationPolicyPage from './pages/RefundCancellationPolicyPage';
import TermsOfService from './pages/TermsOfService';
import WarrantyPolicyPage from './pages/WarrantyPolicyPage';
import DisclaimerPage from './pages/DisclaimerPage';
import IphoneFixInDelhi from './pages/IphoneFixInDelhi';
import IphoneDisplayRepairDelhiNcr from './pages/IphoneDisplayRepairDelhiNcr';
import IphoneBackGlassRepairDelhiNcr from './pages/IphoneBackGlassRepairDelhiNcr';
import IphoneBatteryRepairDelhiNcr from './pages/IphoneBatteryRepairDelhiNcr';
import IphoneChargingPortRepairDelhiNcr from './pages/IphoneChargingPortRepairDelhiNcr';
import IphoneCameraRepairDelhiNcr from './pages/IphoneCameraRepairDelhiNcr';
import IphoneMicSpeakerRepairDelhiNcr from './pages/IphoneMicSpeakerRepairDelhiNcr';
import MacbookRepair from './pages/MacbookRepair';
import './App.css';

function HomePage() {
  return (
    <>
      <Hero />
      <Services isHome={true} />
      <Benefits />
      <BookingForm />
      <Testimonials />
      <FAQ />
      <CtaBanner />
    </>
  );
}

function App() {
  useEffect(() => {
    initPhoneConversionUpdater();
  }, []);

  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/electrician" element={<Electrician />} />
        <Route path="/iphone-repair" element={<IphoneRepair />} />
        <Route path="/iphone-fix-in-delhi" element={<IphoneFixInDelhi />} />
        <Route path="/iphone-display-repair-delhi-ncr" element={<IphoneDisplayRepairDelhiNcr />} />
        <Route path="/iphone-back-glass-repair-delhi-ncr" element={<IphoneBackGlassRepairDelhiNcr />} />
        <Route path="/iphone-battery-repair-delhi-ncr" element={<IphoneBatteryRepairDelhiNcr />} />
        <Route path="/iphone-charging-port-repair-delhi-ncr" element={<IphoneChargingPortRepairDelhiNcr />} />
        <Route path="/iphone-camera-repair-delhi-ncr" element={<IphoneCameraRepairDelhiNcr />} />
        <Route path="/iphone-mic-speaker-repair-delhi-ncr" element={<IphoneMicSpeakerRepairDelhiNcr />} />
        <Route path="/macbook-repair" element={<MacbookRepair />} />
        <Route path="/macbook-repair-service" element={<MacbookRepair />} />
        <Route path="/data-recovery" element={<DataRecovery />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/refund-cancellation-policy" element={<RefundCancellationPolicyPage />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/warranty-policy" element={<WarrantyPolicyPage />} />
        <Route path="/disclaimer" element={<DisclaimerPage />} />
      </Routes>
      <Footer />
      <FloatingContact />
    </Router>
  );
}

export default App;
